import React from 'react';

const ROWS = 6;
const COLS = 7;

const Connect4Board = ({ gameState, isMyTurn, onMove, currentUserId }) => {
  const { board, currentPlayer, player1_id, winner, isDraw, winningLine } = gameState;
  
  const isMyPiece = (piece) => {
    if (piece === 0) return false;
    return (piece === 1 && currentUserId === player1_id) || 
           (piece === 2 && currentUserId !== player1_id);
  };
  
  const isWinningCell = (row, col) => {
    return winningLine?.some(cell => cell.row === row && cell.col === col);
  };
  
  const handleColumnClick = (col) => {
    if (!isMyTurn || winner || isDraw) return;
    
    // Check if column is full
    if (board[0][col] !== 0) return;
    
    onMove({ col });
  };
  
  const getPieceColor = (piece) => {
    if (piece === 0) return 'bg-slate-700/50';
    return piece === 1 ? 'bg-red-500' : 'bg-yellow-400';
  };
  
  return (
    <div className="flex flex-col items-center gap-3 sm:gap-4 p-3 sm:p-4 md:p-6">
      {/* Status */}
      <div className="text-center">
        {winner ? (
          <div className="text-xl font-bold text-emerald-400">
            {winner === currentUserId ? ' You Won!' : ' You Lost'}
          </div>
        ) : isDraw ? (
          <div className="text-xl font-bold text-slate-400">Draw!</div>
        ) : (
          <div className="text-lg">
            {isMyTurn ? (
              <span className="text-emerald-400 font-semibold">Your Turn</span>
            ) : (
              <span className="text-slate-400">Opponent's Turn</span>
            )}
          </div>
        )}
      </div>
      
      {/* Board */}
      <div className="bg-blue-600 p-3 rounded-2xl shadow-2xl">
        <div className="grid gap-2" style={{ gridTemplateColumns: `repeat(${COLS}, 1fr)` }}>
          {board.map((row, rowIndex) =>
            row.map((cell, colIndex) => (
              <button
                key={`${rowIndex}-${colIndex}`}
                onClick={() => handleColumnClick(colIndex)}
                disabled={!isMyTurn || winner || isDraw || board[0][colIndex] !== 0}
                className={`
                  w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 rounded-full
                  transition-all duration-200
                  ${getPieceColor(cell)}
                  ${isWinningCell(rowIndex, colIndex) ? 'ring-4 ring-white animate-pulse' : ''}
                  ${isMyTurn && !winner && !isDraw && board[0][colIndex] === 0 ? 'hover:brightness-110 cursor-pointer' : 'cursor-default'}
                  disabled:opacity-50
                `}
                aria-label={`Row ${rowIndex + 1}, Column ${colIndex + 1}`}
              />
            ))
          )}
        </div>
      </div>
      
      {/* Legend */}
      <div className="flex gap-6 text-sm">
        <div className="flex items-center gap-2">
          <div className={`w-6 h-6 rounded-full ${isMyPiece(1) ? 'bg-red-500' : 'bg-yellow-400'}`} />
          <span className="text-white/70">You</span>
        </div>
        <div className="flex items-center gap-2">
          <div className={`w-6 h-6 rounded-full ${isMyPiece(1) ? 'bg-yellow-400' : 'bg-red-500'}`} />
          <span className="text-white/70">Opponent</span>
        </div>
      </div>
    </div>
  );
};

export default Connect4Board;
